module.exports = __webpack_public_path__ + "static/media/Kayle.308c8826.png";